__turbopack_context__.v({
  "description": "InputSelection-module-scss-module__bgCyoW__description",
  "fade-in": "InputSelection-module-scss-module__bgCyoW__fade-in",
  "input": "InputSelection-module-scss-module__bgCyoW__input",
  "label": "InputSelection-module-scss-module__bgCyoW__label",
  "meta": "InputSelection-module-scss-module__bgCyoW__meta",
  "no-transform": "InputSelection-module-scss-module__bgCyoW__no-transform",
  "rotate": "InputSelection-module-scss-module__bgCyoW__rotate",
  "wrapper": "InputSelection-module-scss-module__bgCyoW__wrapper",
});
